import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Form, Input, Row, Col, Divider, Select } from "antd";

const { Option } = Select;

const Step3Industries = () => {
    const { control } = useFormContext();

    return (
        <div style={{ background: "#fff", padding: 25, borderRadius: 8 }}>
            {/* ---------------- SECTION 1 ---------------- */}
            <h5 style={{ marginBottom: 25, fontWeight: 600 }}>Eligibility & Independence</h5>

            <Form layout="vertical">
                <Row gutter={24}>
                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Ensure that the firm is qualified and is eligible to accept the appointment in terms the Companies.
                        </p>
                        <Form.Item>
                            <Controller
                                name="eligibleFirm"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Ensure that there is compliance with the firm’s rules and procedures as described in the BDO East Africa
                        </p>
                        <Form.Item>
                            <Controller
                                name="complianceRules"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                {/* ---------------- SECTION 2 ---------------- */}
                <Divider style={{ margin: "30px 0 20px" }} />
                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>The Prospective Client’s Reputation</h5>

                <Row gutter={24}>
                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Discuss the prospective client with the person who referred them, and note below their comments
                        </p>
                        <Form.Item>
                            <Controller
                                name="referredDiscussion"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Obtain and review the prospective client’s financial statements, recent annual returns
                        </p>
                        <Form.Item>
                            <Controller
                                name="financialReview"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                {/* Duplicate block because image shows repeated fields */}
                <Row gutter={24}>
                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Discuss the prospective client with the partner and managers who referred them in the firm, and note below their comments
                        </p>
                        <Form.Item>
                            <Controller
                                name="referredDiscussionAgain"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            If the above procedures are inconclusive, contact friends of the firm who may know the client
                        </p>
                        <Form.Item>
                            <Controller
                                name="financialReviewAgain"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                {/* ---------------- IN CASES OF INTERNATIONAL REFERRALS ---------------- */}
                <Divider style={{ margin: "30px 0 20px 0" }} />
                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>In cases of International Referrals</h5>

                <Row gutter={24}>
                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Has the prospective client’s reputation been discussed with the parent engagement partner?
                        </p>
                        <Form.Item>
                            <Controller
                                name="discussedWithParentPartner"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Has the prospective client’s reputation been discussed with the International Liaison Partner?
                        </p>
                        <Form.Item>
                            <Controller
                                name="discussedWithInternationalPartner"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Have the other member firm’s acceptance procedures been considered?
                        </p>
                        <Form.Item>
                            <Controller
                                name="otherFirmProcedures"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        {/* EMPTY TO MAINTAIN GRID BALANCE */}
                    </Col>
                </Row>



                {/* ---------------- PREVIOUS AUDITORS SECTION ---------------- */}
                <Divider style={{ margin: "30px 0 20px 0" }} />
                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                    Previous Auditors – for new Audit and assurance clients only
                </h5>

                <Row gutter={24}>
                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Request the prospective client to authorize the previous auditors to respond fully to our inquiries
                        </p>
                        <Form.Item>
                            <Controller
                                name="authorizePreviousAuditors"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            The previous auditors, to determine if there is any reason why the firm should not accept engagement
                        </p>
                        <Form.Item>
                            <Controller
                                name="previousAuditorsDecision"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Make personal contact with the previous auditor to discuss matters relating to the prior year engagement
                        </p>
                        <Form.Item>
                            <Controller
                                name="contactPreviousAuditor"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            The prospective client, as to why (and how frequently) the company is changing auditors
                        </p>
                        <Form.Item>
                            <Controller
                                name="changingAuditorsReason"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                {/* ---------------- ACCESS TO PREVIOUS AUDITOR WORKING PAPERS ---------------- */}
                <Row gutter={24} style={{ marginTop: 20 }}>
                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Request access to the previous auditors’ working papers as relevant
                        </p>
                        <Form.Item>
                            <Controller
                                name="accessAuditorWorkingPapers"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}></Col>
                </Row>


                {/* ---------------- ABILITY TO SERVE THE CLIENT ---------------- */}
                <Divider style={{ margin: "30px 0 20px 0" }} />
                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                    Ability to serve the client is the firm able to comply with the following
                </h5>

                <Row gutter={24}>
                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Ensure that appropriate partners and staff are available to perform the audit, in compliance with
                        </p>
                        <Form.Item>
                            <Controller
                                name="staffAvailability"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Ascertain that the firm has, or can obtain, any specialist expertise required to
                        </p>
                        <Form.Item>
                            <Controller
                                name="specialistExpertise"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>


                {/* ---------------- FEES SECTION ---------------- */}
                <Divider style={{ margin: "30px 0 20px 0" }} />
                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>Fees</h5>

                <Row gutter={24}>
                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            The agreed principal basis on which the fees shall be charged.
                        </p>
                        <Form.Item>
                            <Controller
                                name="feeBasis"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            Is the firm independent with respect to the client regarding the current fee arrangement
                        </p>
                        <Form.Item>
                            <Controller
                                name="independentFeeArrangement"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <p style={{ fontSize: 14, marginBottom: 6 }}>
                            In case of a pro-bono engagement, please justify the rationale
                        </p>
                        <Form.Item>
                            <Controller
                                name="proBonoRationale"
                                control={control}
                                render={({ field }) => <Input placeholder="Done" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}></Col>
                </Row>
                {/* ---------------- INVESTIGATION OF INDUSTRY BACKGROUND & RISK FACTORS ---------------- */}
                <Divider style={{ margin: "30px 0 20px 0" }} />
                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                    Investigation of industry background and other risk factors, Note below the results of investigation into
                    the following factors in evaluating the potential business risk to the firm
                </h5>

                <Row gutter={24}>
                    <Col span={12}>
                        <p>Client’s type of business and brief details about the industry</p>
                        <Form.Item>
                            <Controller
                                name="industryBackground"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p>Are there any negative concerns about the prospect client’s marketplace or its directors</p>
                        <Form.Item>
                            <Controller
                                name="negativeConcernsMarket"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <p>Is the prospective client publicly held, or expecting public offering in the near future?</p>
                        <Form.Item>
                            <Controller
                                name="publicHeld"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p>Management’s attitude to control systems, its plan to address potential problems, and the viability</p>
                        <Form.Item>
                            <Controller
                                name="managementAttitude"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <p>The apparent competence of accounting, financial and data processing personnel, and the adequacy</p>
                        <Form.Item>
                            <Controller
                                name="accountingCompetence"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p>Has the prospective client, or any of its director or shareholders, been convicted of a crime</p>
                        <Form.Item>
                            <Controller
                                name="crimeConviction"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <p>Is there substantial doubt concerning the prospective client’s ability to continue in existence</p>
                        <Form.Item>
                            <Controller
                                name="abilityContinue"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p>Recent continuity of management, and its perceived competence</p>
                        <Form.Item>
                            <Controller
                                name="continuityManagement"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <p>The financial needs of the company, and its ability to meet those needs in the future</p>
                        <Form.Item>
                            <Controller
                                name="financialNeedsCompany"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <p>The rapidity of growth in recent years, and the source of such growth (i.e internal growth, merger)</p>
                        <Form.Item>
                            <Controller
                                name="growthSource"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <p>Has the prospective clients character, Integrity and reputation been discussed with its merchant</p>
                        <Form.Item>
                            <Controller
                                name="characterIntegrity"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>


                <Row gutter={24}>
                    <Col span={12}>
                        <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                            litigation
                        </h5>
                        <Form.Item label="Are we satisfied that there is no litigation taking place, or likely to take place between the firm">
                            <Controller
                                name="noLitigation"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter name" {...field} />}
                            />
                        </Form.Item>
                    </Col>



                    <Col span={12}>
                        <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                            Close Relationships
                        </h5>
                        <Form.Item label="Can we confirm that no partners, or staff engaged in the client affairs have family connections">
                            <Controller
                                name="noFamilyConnections"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter name" {...field} />}
                            />
                        </Form.Item>
                    </Col>



                </Row>


                <Row gutter={24}>
                    <Col span={12}>
                        <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                            Financial Interest
                        </h5>
                        <Form.Item label="Can we confirm that any partners(or closely connected person), or member of staff engaged ">
                            <Controller
                                name="confirmPartnerConnections"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter name" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                            Conflict of Interest
                        </h5>
                        <Form.Item label="Are we satisfied that there no limitation of scope which will be imposed on our work by engagement">
                            <Controller
                                name="noScopeLimitations"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter name" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                </Row>

                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                    Limitation of Scope
                </h5>
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Client type of business and brief details about the industry">
                            <Controller
                                name="clientBusinessDetails"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter name" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                </Row>
                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                    Other Independence Issue
                </h5>
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Are we satisfied that there are no other factors which could impact our independence?">
                            <Controller
                                name="noOtherImpairments"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter name" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Have we satisfied ourselves that there were no other factors existing during the period">
                            <Controller
                                name="noOtherFactorsPeriod"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter name" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                </Row>
                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                    Risk Rating Form
                </h5>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Listed on a stock exchange">
                            <Controller
                                name="listedOnStockExchange"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Anticipating a public offering within the next two years">
                            <Controller
                                name="anticipatingPublicOffering"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Could be subject of a buy-out or takeover">
                            <Controller
                                name="buyoutOrTakeover"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Involved in high-tech, emerging or heavily/highly regulated industry">
                            <Controller
                                name="highTechOrRegulatedIndustry"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Any other Public Interest Entity or Publicly Accountable Entity">
                            <Controller
                                name="publicInterestEntity"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Aggressive accounting policies; undue emphasis">
                            <Controller
                                name="aggressiveAccountingPolicies"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Complex accounting principles">
                            <Controller
                                name="complexAccountingPrinciples"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Continuing losses and/or experiencing liquidity issues">
                            <Controller
                                name="continuingLosses"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Unrealistic reporting deadlines">
                            <Controller
                                name="unrealisticReportingDeadlines"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Poor debt position relative to industry norms">
                            <Controller
                                name="poorDebtPosition"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Domineering chief executive / management">
                            <Controller
                                name="dominatingManagement"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Weak internal controls and poor management">
                            <Controller
                                name="weakInternalControls"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Engages in offshore transactions in tax havens">
                            <Controller
                                name="offshoreTaxHavens"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Has foreign subsidiaries / affiliates">
                            <Controller
                                name="foreignSubsidiaries"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Client / management reputation sullied">
                            <Controller
                                name="reputationSullied"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Disputes, unresolved issues with predecessor audit">
                            <Controller
                                name="predecessorAuditIssues"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Is evasive or abusive to BDO East Africa staff">
                            <Controller
                                name="evasiveOrAbusiveBehavior"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter details" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>
                </Row>


                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                    Conclusion and acceptance approval
                </h5>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Relationship / Liaison Manager">
                            <Controller
                                name="liaisonConclusion"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter name" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Signature">
                            <Controller
                                name="signature"
                                control={control}
                                render={({ field }) => <Input placeholder="Signature" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Date">
                            <Controller
                                name="conclusionDate"
                                control={control}
                                render={({ field }) => <Input type="date" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>



            </Form>
        </div>
    );
};

export default Step3Industries;
